/** @format */

import { shallowEqual, useSelector } from "react-redux";
import ModalValidasiDanaBos from "../../components/Modal/ModalValidasiDanaBos";
import ModalInformation from "../../components/Modal/ModalInformation";
import { useDashboard } from "hooks/HookBos/useDashboard";
import {
  CardStatistik,
  CardStatistikDetail,
  CardStatistikProgress,
} from "./Component/CardStatistik";
import { CardChart } from "./Component/CardChart";
import { CardTable } from "./Component/CardTable";
import { FilterForm } from "./Component/FilterForm";
import { countPersentase } from "utils/helper";
import { useEffect, useState } from "react";
import { ButtonExport } from "components/Button";
import { ExportToExcel } from "components/Export/ExportToExcel";
import notifAlert from "../../components/NotifAlert";

const Dashboard = () => {
  const { auth, store } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
      store: state.store,
    }),
    shallowEqual,
  );
  const [filter, setFilter] = useState<any>({});

  const { header1, header2, header3, akb, snp, fetchData, loading } =
    useDashboard(auth);

  useEffect(() => {
    if (!auth?.isTahun) return;

    fetchData(true, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.isTahun, filter]);

  const dataMadrasah =
    auth?.group_role === "madrasah" ? [{ ...header1, ...auth?.madrasah }] : [];

  const handleExportDetailLokasi = () => {
    try {
      const xls = (header2 || []).map((el: any) => ({
        Nama: el.namaDaerah,
        "Rencana Selesai": el.rencanaSelesai,
        "Rencana Belum Selesai": el.rencanaBelumSelesai,
        "Realisasi Selesai": el.realisasiSelesai,
        "Realisasi Belum Selesai": el.realisasiBelumSelesai,
      }));
      ExportToExcel(xls, "dashboard-detail-alokasi");
      notifAlert({ type: "success", description: "Data berhasil di export" });
    } catch (error) {
      notifAlert({ type: "error", description: "Data gagal di export" });
    }
  };

  return (
    <>
      <ModalValidasiDanaBos
        dataAuth={auth}
        dataStore={store}
        dataYear={auth?.isTahun}
      />
      {auth?.group_role !== "pusat" && <ModalInformation />}

      <div className="p-5">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <CardStatistik
            title="Saldo Realisasi"
            valuePrimary={header1?.saldoRealisasi || 0}
            titleSecondary="Pengembalian Dana"
            valueSecondary={header1?.pengembalian_dana || 0}
            prefix="Rp"
            loading={loading}
          />
          <CardStatistikProgress
            title="Pendapatan"
            valuePrimary={header1?.anggaranPendapatan || 0}
            valueSecondary={header1?.realisasiPendapatan || 0}
            persent={countPersentase(
              header1?.realisasiPendapatan,
              header1?.anggaranPendapatan,
            )}
            prefix="Rp"
            loading={loading}
          />
          <CardStatistikProgress
            title="Belanja"
            valuePrimary={header1?.anggaranBelanja || 0}
            valueSecondary={header1?.realisasiBelanja || 0}
            persent={countPersentase(
              header1?.realisasiBelanja,
              header1?.anggaranBelanja,
            )}
            prefix="Rp"
            loading={loading}
          />
          <FilterForm
            handleFilter={(values) =>
              setFilter({
                kodeProvinsi: values?.provinsi,
                kodeKabKota: values?.kabkota,
                nsm: values?.madrasah,
                kodeSumberDana: values?.kodeSumberDana,
              })
            }
            formLayout="vertical"
            loading={loading}
          />
        </div>
        {(auth?.group_role !== "madrasah" && (
          <>
            <div className="flex flex-col md:flex-row  gap-4 mb-4">
              <CardStatistikDetail
                title="Rencana"
                valuePrimary={header1?.rencanaSelesai || 0}
                valueSecondary={header1?.rencanaBelumSelesai || 0}
                prefix="Rp"
                loading={loading}
              />
              <CardStatistikDetail
                title="Realisasi"
                valuePrimary={header1?.realisasiSelesai || 0}
                valueSecondary={header1?.realisasiBelumSelesai || 0}
                prefix=""
                loading={loading}
              />
            </div>
            <div className="flex justify-end mb-2">
              <ButtonExport
                title="Unduh Excel"
                onClick={handleExportDetailLokasi}
              />
            </div>
            <CardTable
              title=""
              data={header2 || []}
              type="detailLokasi"
              loading={loading}
            />
          </>
        )) || (
          <>
            <CardTable
              title=""
              data={dataMadrasah}
              type="detailMadrasah"
              loading={loading}
            />
          </>
        )}
        <CardChart
          title="Pendapatan dan Belanja"
          data={header3 || []}
          type="column"
          loading={loading}
        />

        <CardChart
          title="Anggaran Kas Belanja"
          data={akb || []}
          type="line"
          loading={loading}
        />
        <CardTable title="" data={snp || []} type="snp" loading={loading} />
      </div>
    </>
  );
};

export default Dashboard;
